import * as React from 'react';
import * as styles from './breadcrumb.module.scss';
import Anchor from '../../anchor/anchor';
import { CurrentNavSegmentsContext } from '../../../hooks/current-nav-segments';
import ChevronRight from '../../icons/chevron-right';


const SfBreadcrumb = () => {
    const currentNavSegments = React.useContext(CurrentNavSegmentsContext);

    const items = React.useMemo(() => {
        const result = currentNavSegments
            .filter(segment => !segment.indexPage && !segment.hidden)
            .map(s => {
                const title = s.title;
                const url = s.relativeUrl || s.childrenSegments?.find(c => c.indexPage)?.relativeUrl;
                const disabled = url === currentNavSegments[0]?.relativeUrl;
                return { title, url, disabled };
            });

        if (result.length > 0) {
            result.push({ title: 'Home', url: '/' });
        }

        result.reverse();

        return result.filter(item => item.url);
    },
        [currentNavSegments]);

    return <>
        {
            items.length > 0 && <>
                <div className={styles.container}>
                    {
                        items.map((item, ix) => <React.Fragment key={item.title}>
                            <Anchor href={item.url} className={styles.item} disabled={item.disabled} >{item.title}</Anchor>
                            {ix < items.length - 1 && <ChevronRight className={styles.separator} />}
                        </React.Fragment>)
                    }
                </div>
            </>
        }
    </>
}

export default SfBreadcrumb;